import qs from "qs";
import ApiClient, { ApiClientPromiseResponse } from "services/ApiClient";
import { PendingReport, ReportData, ReportListItem } from "types/report";

class ReportsService extends ApiClient {
  getReports({ projectId }: { projectId: string }): ApiClientPromiseResponse<ReportListItem[]> {
    return this.call<ReportListItem[]>({
      method: "get",
      url: `/reports?${qs.stringify({ projectId })}`,
    });
  }

  getPendingReport(projectId: string): ApiClientPromiseResponse<PendingReport> {
    return this.call<PendingReport>({
      method: "get",
      url: `/reports/pending?${qs.stringify({ projectId })}`,
    });
  }

  getReportData(id: string): ApiClientPromiseResponse<ReportData> {
    return this.call<ReportData>({
      method: "get",
      url: `/reports/report-data?${qs.stringify({ id })}`,
      timeout: 600000,
    });
  }

  getContactsForDropdown(data: any) {
    return this.call({
      method: "get",
      url: `/reports/share/dropdown?${qs.stringify(data)}`,
    });
  }

  createMainReport(data: any) {
    return this.call({
      method: "post",
      url: "/reports/main",
      data,
    });
  }

  updateMainReport(data: any) {
    return this.call({
      method: "put",
      url: "/reports/main",
      data,
    });
  }

  sendMainReportForApproval(data: any) {
    return this.call({
      method: "put",
      url: "/reports/main/send-for-approval",
      data,
    });
  }

  shareReport(data: any) {
    return this.call({
      method: "post",
      url: "/reports/share",
      data,
    });
  }

  createAbridgedReport(data: any) {
    return this.call({
      method: "post",
      url: "/reports/abridged",
      data,
    });
  }

  createCompiledAbridgedReport(data: any) {
    return this.call({
      method: "post",
      url: "/reports/compiled-abridged",
      data,
    });
  }

  approveAbridgedReport({ id }: { id: string }) {
    return this.call({
      method: "put",
      url: `/reports/abridged/${id}/approve`,
      data: { id },
    });
  }

  rejectAbridgedReport({ id }: { id: string }) {
    return this.call({
      method: "put",
      url: `/reports/abridged/${id}/reject`,
      data: { id },
    });
  }

  createPreliminaryReport(data: any) {
    return this.call({
      method: "post",
      url: "/reports/preliminary",
      data,
    });
  }

  getReportConfiguration(id: string) {
    return this.call({
      method: "get",
      url: `/reports/main/${id}/configuration`,
    });
  }

  getAbridgedReportNeedsApproval(data: any) {
    return this.call({
      method: "get",
      url: `/reports/abridged/requires-approval?${qs.stringify(data)}`,
    });
  }
}

export default new ReportsService();
